import { put } from 'redux-saga/effects';

import { createFeatureFlag } from '../../commons/featureFlags';
import { featureSelector } from '../../commons/featureFlags/featureSelector';
import Constants from '../../commons/utils/Constants';
import LanguageDirectoryActions from './LanguageDirectoryActions';

const { languageDirectoryUrl } = Constants.conductorConfig;

export const flagDirectoryLanguageUrl = createFeatureFlag(
  'directory.language.url',
  'https://source-academy.github.io/language-directory/directory.json',
  'The URL where the language directory may be found.',
  // Pin to the configured URL whenever one is set, independent of conductor.enable, so the
  // directory is always fetched over HTTP from REACT_APP_LANGUAGE_DIRECTORY_URL.
  languageDirectoryUrl,
  function* () {
    yield put(LanguageDirectoryActions.fetchLanguages());
  },
);

export const selectDirectoryLanguageUrl = featureSelector(flagDirectoryLanguageUrl);
